<template>
  <div v-if="bodyPartType !== undefined " class="customisation-tab-button" :class="bodyPartType" v-on:click="clicked">
    <button class="btn">
      <span class="icon" :class="bodyPartType"></span>
    </button>
  </div>

  <div v-if="accessoryType !== undefined " class="customisation-tab-button" :class="accessoryType" v-on:click="clicked">
    <button class="btn">
      <span class="icon" :class="accessoryType"></span>
    </button>
    <div v-if="showNotification" class="notification"></div>
  </div>
</template>

<script>


  import {BodyPartNames} from "@/mixins/BodyPartNames";
  import {AccessoryNames} from "@/mixins/AccessoryNames";

  export default {
    name: "CustomisationTabButton",
    components: {},
    mixins: [BodyPartNames, AccessoryNames],
    emits: ["clicked"],
    props: {
      bodyPartType: String,
      accessoryType: String,
      showNotification: Boolean,
    },
    data() {
      return {
        bodyPartNames: BodyPartNames,
        accessoryNames: AccessoryNames,
      }
    },
    computed: {},

    methods: {
      clicked() {
        if (this.bodyPartType !== undefined) {
          this.$emit('clicked', this.bodyPartType);
        } else {
          this.$emit('clicked', this.accessoryType);

        }
      },
      closeButton() {
        this.visible = false;
      }
    },
    mounted() {

    },
    created() {

    }
  }

</script>

<style lang="scss" scoped>
  .customisation-tab-button {
    display: flex;
    flex: 1 1;
    position: relative;
  }

  .btn {
    margin: 0px 0px;
    padding: 0;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/image/customise/bb_category.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    .icon {
      width: 100%;
      height: 100%;
      display: block;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  .notification {
    width: 45%;
    height: 45%;
    background-image: url("~@/assets/image/platform/activities/bb_notification-orange.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    right: 0;
  }

  .customisation-tab-button.selected > .btn {
    background-image: $selected-category;
  }

  .icon.eyes {
    background-image: $category-eyes;
  }

  .icon.mouth {
    background-image: $category-mouth;
  }

  .icon.nose {
    background-image: $category-nose;
  }

  .icon.ear_left {
    background-image: $category-ears;
  }

  .icon.antenna {
    background-image: $category-antenna;
  }

  .icon.whiskers {
    background-image: $category-cheeks;
  }

  //accessories

  .icon.hand {
    background-image: $category-accessory;
  }

  .icon.shirt {
    background-image: $category-body;
  }

  .icon.hat {
    background-image: $category-hat;
  }

  .icon.shoe_left {
    background-image: $category-shoes;
  }

  .icon.pants {
    background-image: $category-pants;
  }

</style>